import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import mouService from "./mouService";

export const getMous = createAsyncThunk(
  "mous/get-mouslist",
  async (thunkAPI) => {
    try {
      return await mouService.getMous();
      
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const createMous = createAsyncThunk(
  "mous/create-state",
  async (mouData, thunkAPI) => {
    try {
      return await mouService.createMous(mouData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getAMous = createAsyncThunk(
  "mous/get-mous",
  async (id, thunkAPI) => {
    try {
      return await mouService.getAMous(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateAMous = createAsyncThunk(
  "mous/update-state",
  async (brand, thunkAPI) => {
    try {
      return await mouService.updateAMous(brand);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAMous = createAsyncThunk(
  "mous/delete-state",
  async (id, thunkAPI) => {
    try {
      return await mouService.deleteAMous(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  mous: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const mouSlice = createSlice({
  name: "mous",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMous.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMous.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.mous = action.payload;
      })
      .addCase(getMous.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createMous.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createMous.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdMOU = action.payload;
      })
      .addCase(createMous.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export default mouSlice.reducer;
